import React, { useEffect, useState } from "react";
import "./Blog.css";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch("http://localhost:5000/api/blogs");
        const data = await res.json();
        setBlogs(data);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };
    fetchBlogs();
  }, []);


  const slugify = (text) => {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[\s_]+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
  };

  const goToBlog = (blog) => {
    const slug = slugify(blog.title);
    window.location.href = `/blogs/${slug}/${blog.id}`;
  };


  const getImageUrl = (path) => (path ? `http://localhost:5000/${path}` : "");

  return (
    <div className="blog-hbt-wrapper">
      {/* Hero Section */}
      <section className="blog-hbt-hero">
        <h1 className="blog-hbt-hero-title">Explore Our Latest Insights</h1>
        <p className="blog-hbt-hero-subtitle">
          Trends, tutorials, and tips from our experts
        </p>
      </section>

      <section className="blog-hbt-grid">
        {blogs.length > 0 ? (
          blogs.map((blog) => (
            <div key={blog.id} className="blog-hbt-card">
              <img
                src={getImageUrl(blog.image1)}
                alt={blog.title}
                className="blog-hbt-card-image"
                onClick={() => goToBlog(blog)}
                style={{ cursor: "pointer" }}
              />
              <div className="blog-hbt-card-content">
                <h3
                  className="blog-hbt-card-title"
                  onClick={() => goToBlog(blog)}
                  style={{ cursor: "pointer" }}
                >
                  {blog.title}
                </h3>
                <p className="blog-hbt-card-text">
                  {Array.isArray(blog.description)
                    ? blog.description.join(" ")
                    : blog.description}
                </p>
                <button className="blog-hbt-btn" onClick={() => goToBlog(blog)}>
                  Continue Reading →
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="blog-hbt-no-blogs">No blogs available.</p>
        )}
      </section>


      {/* Newsletter Signup */}
      <section className="blog-hbt-newsletter">
        <h2 className="blog-hbt-newsletter-title">Subscribe to Our Newsletter</h2>
        <p className="blog-hbt-newsletter-subtext">
          Get the latest blog updates straight to your inbox.
        </p>
        <form className="blog-hbt-newsletter-form">
          <input
            type="email"
            placeholder="Your email address"
            className="blog-hbt-input"
          />
          <button className="blog-hbt-btn">Subscribe</button>
        </form>
      </section>
    </div>
  );
};

export default Blog;
